import { Link } from "react-router-dom";

import { useI18n } from "@/shared/i18n/LanguageContext";

type ResumeGameProps = {
  gameId: string;
  modelId: string;
  state: string;
  moveCount: number;
};

export function ResumeGame({
  gameId,
  modelId,
  state,
  moveCount,
}: ResumeGameProps) {
  const { copy } = useI18n();
  return (
    <section className="resume-game">
      <div className="resume-game__copy">
        <p className="resume-game__eyebrow">{copy.play.resume.eyebrow}</p>
        <h2>{copy.play.resume.title}</h2>
        <p>{copy.play.resume.body}</p>
      </div>

      <div className="resume-game__meta">
        <div className="resume-game__meta-card">
          <span>{copy.play.resume.model}</span>
          <strong>{modelId}</strong>
        </div>
        <div className="resume-game__meta-card">
          <span>{copy.play.resume.state}</span>
          <strong>{state}</strong>
        </div>
        <div className="resume-game__meta-card">
          <span>{copy.play.resume.moves}</span>
          <strong>{moveCount}</strong>
        </div>
      </div>

      <div className="resume-game__actions">
        <Link className="button-link button-link--primary" to={`/play/session/${gameId}`}>
          {copy.play.resume.action}
        </Link>
      </div>
    </section>
  );
}
